import Component from '../Component';
import LevelNode from '../../Prototype/World/LevelNode/LevelNode';

export default class SagaMapComponent extends Component {
    public levelNodes?: Map<number, LevelNode>;
}
